export enum CommentContentType {
  Text = 5,
  Image = 6,
  Gif = 7,
}

export enum PostContentType {
  Text = 1,
  Image = 2,
  Video = 3,
  Gif = 4,
}

/**
 * Conversation message types — matches backend MessageType lookup.
 * 1 Text | 2 Image | 3 Video | 4 File | 5 System | 6 AIResponse
 */
export enum ChatContentType {
  Text = 1,
  Image = 2,
  Video = 3,
  File = 4,
  System = 5,
  AIResponse = 6,
}
